import * as React from "react";

import {
  makeStyles,
  Body1,
  Caption1,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    width: "720px",
    maxWidth: "100%",
  },
});

export interface AnnouncementProps
{
    id: string;
    title: string | React.ReactElement | React.ReactNode;
    date: string;
    logo?: React.ReactElement;
    previewContent?: React.ReactElement | React.ReactNode;
    footer?: React.ReactElement | React.ReactNode;
}

export const Announcement: React.FC<AnnouncementProps> = ({ title, date, logo, previewContent, footer }) => {
  const styles = useStyles();

  return (
    <Card className={styles.card}>
      <CardHeader
        image={<img src="/favicon-32x32.png" alt="Ianus Guard icon" />}
        header={
          <Body1>
            { title }
          </Body1>
        }
        description={<Caption1>{ date }</Caption1>}
      />

      <CardPreview
        logo={logo}
      >
        { previewContent }
      </CardPreview>

      <CardFooter>
        { footer }
      </CardFooter>
    </Card>
  );
};